import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { fadeInRight400ms } from 'src/@smartmanufacturing/animations/fade-in-right.animation';
import { fadeInUp400ms } from 'src/@smartmanufacturing/animations/fade-in-up.animation';
import { scaleIn400ms } from 'src/@smartmanufacturing/animations/scale-in.animation';
import { DateFormat } from 'src/app/user-management/plant-setup/models/DateFormat-Model';
import { ReportFormat } from 'src/app/user-management/plant-setup/models/report-Format';
import { TimeFormat } from 'src/app/user-management/plant-setup/models/timeFormat-model';
import { UserProfile, UserPlant } from 'src/app/user-management/user-management-setup/models/user';
import { BaseApi } from 'src/backend/api/base-api';
import { PlantService } from 'src/backend/services/user-access-services/plant.service';
import { UserService } from 'src/backend/services/user-access-services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  animations: [fadeInUp400ms, fadeInRight400ms, scaleIn400ms],
})
export class UserProfileComponent implements OnInit {
  @ViewChild('userFormatModel') userFormatModel: TemplateRef<any>;
  @ViewChild('avatarInput') avatarInput: ElementRef;
  userProfile: UserProfile;
  userCode: string;
  uploadedImage: any;
  uploadedImageSrc: string;
  isUploading: boolean;
  plantCode: string = '';
  defaultPlant: UserPlant;
  isEditing = false; // Controls the edit mode
  selectedDateFormat: string | null = null; // Holds the selected date format
  filteredDateFormatList!: any[];
  dateFormatList!: any[];
  timeformatlist!: any[];
  editMode: boolean = false;
  userprofileForm: FormGroup;
  getCurrencyList: any[];
  fileredCurrencyList: any;
  panelOpenState = false;
  getCurrencyList1: any[];
  fileredCurrencyList1: any[];
  sessionGroup: any;
  userconfigurationId: any;
  userconfiguration: any;
  rolessuperadmin: any;
  reportFormat: { name: string; value: string; }[];
  reportFormatList: { name: string; value: string; }[];
  constructor(
    private baseApi: BaseApi,
    private userService: UserService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private plantService: PlantService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    const user = this.baseApi.getUserSession();
    this.userCode = user.userCode;
    this.plantCode = this.baseApi.getPlantCodeFromStorage();
    this.getProfileInformation();
    this.getUserConfiguration();
    this.createForm();
    this.getCurrencyDetails();

    this.dateFormatList = DateFormat;
    this.timeformatlist = TimeFormat;
    this.filteredDateFormatList = this.dateFormatList.slice();
    this.reportFormat = ReportFormat;
    this.reportFormatList = ReportFormat.slice();
  }
  createForm() {
    this.userprofileForm = this.fb.group({
      dateformat: [''],
      timeformat: [''],
      currencyunit: [''],
      reportNumberFormat: [''],
    });
  }


  getProfileInformation() {
    this.userService.getUserProfile().subscribe({
      next: (response) => {
        this.userProfile = response;
        this.defaultPlant = this.userProfile.userPlants.find((plant: any) => plant.isDefault === true);
        // if(this.userProfile.roles === "Super Admin"){
        //   this.rolessuperadmin = this.userProfile.roles;
        // }
        // else{
        //   this.rolessuperadmin = '';
        // }

      },
      error: ({ error }) => {
        console.log(error);
      },
    });
  }

  onClickUploader() {
    this.avatarInput.nativeElement.value = null;
    this.avatarInput.nativeElement.click();
  }

  onFileChange(event: any) {
    //allow only image types jpeg, jpg, png
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(event.target.files[0].type)) {
      this.toaster.error('Error', 'Please upload only image files');
      return;
    }
    const file = event.target.files[0];
    this.uploadedImage = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.uploadedImageSrc = reader.result as string;
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to change your profile picture?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.isUploading = true;
          const formData = new FormData();
          formData.append('file', this.uploadedImage, this.uploadedImage.name);
          this.userService
            .changeUserPhoto(formData, this.userProfile?.userCode)
            .subscribe({
              next: (response) => {
                this.isUploading = false;
                this.toaster.success('Success', response.message);
                this.getProfileInformation();
              },
              error: ({ error }) => {
                this.isUploading = false;
                this.toaster.error('Error', error.message);
              },
            });
        } else {
          this.isUploading = false;
          this.uploadedImageSrc = null;
          this.uploadedImage = null;
        }
      });
    };
  }


  getCurrencyDetails() {
    this.plantService.getCurrencyDetails().subscribe({
      next: (res) => {

        this.getCurrencyList = res;
        this.fileredCurrencyList = this.getCurrencyList.slice();
      },
      error: ({ error }) => {
        this.toaster.error('Error', error.message);
      }
    })
  }

  // onChangeCurrency(event: any) {
  //   this.getCurrencyList1 = this.getCurrencyList.filter(x => x.id === event.value);
  //   this.fileredCurrencyList1 = this.getCurrencyList1.slice();
  //   this.userprofileForm.get('currencyformat').setValue(this.fileredCurrencyList1[0].id);
  // }

  openModal() {
    // const dateformatValue = this.dateFormatList.find(x => x.format === "MM/DD/YYYY")
    // if (dateformatValue) {
    //   this.userprofileForm.get('dateformat').setValue(dateformatValue);
    // }
    // const currencyValue = this.getCurrencyList.find(x => x.id === 159)
    // if (currencyValue) {
    //   this.userprofileForm.get('currencyunit').setValue(currencyValue.id);
    // }
    // this.getCurrencyList1 = this.getCurrencyList.filter(x => x.id === 159);
    // this.fileredCurrencyList1 = this.getCurrencyList1.slice();
    // const currencyValue1 = this.getCurrencyList1.find(x => x.id === 159)
    // if (currencyValue1) {
    //   this.userprofileForm.get('currencyformat').setValue(currencyValue1.id);
    // }
    if (this.userconfiguration) {
      this.editMode = true;

      const data = this.userconfiguration;
      this.userconfigurationId = data.id;
      const dateformatValue = this.dateFormatList.find(x => x.format === data.dateFormat);
      if (dateformatValue) {
        this.userprofileForm.get('dateformat').setValue(dateformatValue);
      }
      const timeformatValue = this.timeformatlist.find(x => x.format === data.timeFormat);
      if (timeformatValue) {
        this.userprofileForm.get('timeformat').setValue(timeformatValue.format);
      }
      else {
        this.userprofileForm.get('timeformat').setValue('');
      }

      const currencyValue = this.getCurrencyList.find(x => x.id === data.currencyId);
      if (currencyValue) {
        this.userprofileForm.get('currencyunit').setValue(currencyValue.id);
      }
      this.userprofileForm.get('reportNumberFormat').setValue(data?.reportNumberFormat);


      // this.getCurrencyList1 = this.getCurrencyList.filter(x => x.id === data.currencyId);
      // this.fileredCurrencyList1 = this.getCurrencyList1.slice();
      // const currencyValue1 = this.getCurrencyList1.find(x => x.id === data.currencyId)
      // if (currencyValue1) {
      // this.userprofileForm.get('currencyformat').setValue(data.currencyformat);
      // }

    }
    const dialogRef = this.dialog.open(this.userFormatModel, {
      width: '60%',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.editMode = false;
    })
  }

  getUserConfiguration() {
    const companyData = {
      PlantCode: this.plantCode,
      UserCode: this.userCode,
    }
    this.spinner.show();
    this.userService.getUserConfiguartion(companyData).subscribe((respose) => {
      this.userconfiguration = respose[0];
      this.spinner.hide();
    },
      ({ error }) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  createUserConfiguration() {
    const { dateformat, currencyunit, timeformat, reportNumberFormat } = this.userprofileForm.value;

    const companyData = {
      PlantCode: this.plantCode,
      UserCode: this.userCode,
      DateFormat: dateformat.format,
      TimeFormat: timeformat,
      CurrencyId: currencyunit,
      reportNumberFormat: reportNumberFormat,
      currencySymbol: this.fileredCurrencyList.find(c => c.id === currencyunit)?.currencySymbol,
    }
    this.spinner.show();
    this.baseApi.setUserConfigurations(companyData);
    this.userService.createUserConfiguartion(companyData).subscribe((respose) => {
      this.toaster.success(respose.message);
      this.dialog.closeAll();
      this.spinner.hide();
      this.getUserConfiguration()
    },
      ({ error }) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }
  updateUserConfiguration() {
    const { dateformat, currencyunit, timeformat, reportNumberFormat } = this.userprofileForm.value;

    const companyData = {
      Id: this.userconfigurationId,
      PlantCode: this.plantCode,
      UserCode: this.userCode,
      DateFormat: dateformat.format,
      TimeFormat: timeformat,
      CurrencyId: currencyunit,
      reportNumberFormat: reportNumberFormat,
      currencySymbol: this.fileredCurrencyList.find(c => c.id === currencyunit)?.currencySymbol,
    }
    this.spinner.show();
    const localStorageData = { ...companyData };
    delete localStorageData.Id;
    this.baseApi.setUserConfigurations(localStorageData);
    this.userService.updateUserConfiguartion(companyData).subscribe((respose) => {
      this.toaster.success(respose.message);
      this.dialog.closeAll();
      this.spinner.hide();
      this.getUserConfiguration()
    },
      ({ error }) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }
  resetUserConfiguration() {
    const { dateformat, currencyunit, timeformat } = this.userprofileForm.value;
    const data = this.userconfiguration;
    this.userconfigurationId = data.id;
    const companyData = {
      Id: this.userconfigurationId,
      PlantCode: this.plantCode,
      UserCode: this.userCode,
      DateFormat: '',
      TimeFormat: '',
      CurrencyId: null,
      reportNumberFormat: '',
      currencySymbol: ''
    };

    Swal.fire({
      title: 'Are you sure?',
      text: 'This will reset your user configuration settings to default.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, reset it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        const localStorageData = { ...companyData };
        delete localStorageData.Id;
        this.baseApi.setUserConfigurations(localStorageData);

        this.userService.resetUserConfiguartion(companyData).subscribe(
          (response) => {
            Swal.fire('Reset Successful', response.message, 'success');
            this.spinner.hide();
            this.getUserConfiguration();
          },
          ({ error }) => {
            this.spinner.hide();
            Swal.fire('Error', error.message, 'error');
          }
        );
      }
    });
  }
}